import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import lang from '../../constants/Languages.js';

//img
import typeBook from '../../assets/icons/type-book.svg';
import typeJournalItem from '../../assets/icons/cards-light.svg';
import event from '../../assets/icons/event-accent.svg';
import eventSeries from '../../assets/icons/event-series-accent.svg';
import work from '../../assets/icons/work-accent.svg';
import journal from '../../assets/icons/journal-accent.svg';
import journalNumber from '../../assets/icons/journal-number-accent.svg';
import institution from '../../assets/icons/institution-accent.svg';
import series from '../../assets/icons/series-accent.svg';
import person from '../../assets/icons/person-accent.svg';
import linkImg from '../../assets/icons/link.svg';
import bookContent from '../../assets/icons/book-content.svg';
import spectacle from '../../assets/icons/type-spectacle.svg';
import movie from '../../assets/icons/type-movie.svg';
import radio from '../../assets/icons/type-radio.svg';
import tv from '../../assets/icons/type-tv.svg';

import stripHtml from '../../scripts/StripHtml.js';
import { getTextMetadataDataTransformed } from '../../scripts/TextMetadata.js';

const ItemText = ({ clang, text, link, type, newTab, isTransit }) => {
    const getImg = (type) => {
        switch (type) {
            case 'book':
                return <div className="item__text-icon-container">
                            <img src={typeBook} alt={lang[clang].alt.book} className="item__text-icon"/>
                        </div>;
            case 'content':
                return <div className="item__text-icon-container">
                            <img src={bookContent} alt={lang[clang].alt.content} className="item__text-icon"/>
                        </div>;
            case 'journal':
                return <div className="item__text-icon-subcontainer">
                            <img src={journal} alt={lang[clang].alt.journal} className="item__text-icon"/>
                        </div>;
            case 'journal-number':
                return <div className="item__text-icon-subcontainer">
                            <img src={journalNumber} alt={lang[clang].alt.journal_number} className="item__text-icon"/>
                        </div>;
            case 'journal-item':
                return <div className="item__text-icon-container">
                            <img src={typeJournalItem} alt={lang[clang].alt.journal_item} className="item__text-icon"/>
                        </div>;
            case 'event-series':
                return <div className="item__text-icon-subcontainer">
                            <img src={eventSeries} alt={lang[clang].alt.event_series} className="item__text-icon"/>
                        </div>;
            case 'institution':
                return <div className="item__text-icon-subcontainer">
                            <img src={institution} alt={lang[clang].alt.institution} className="item__text-icon"/>
                        </div>;
            case 'person':
                return <div className="item__text-icon-subcontainer">
                            <img src={person} alt={lang[clang].alt.person} className="item__text-icon"/>
                        </div>;
            case 'series':
                return <div className="item__text-icon-subcontainer">
                            <img src={series} alt={lang[clang].alt.series} className="item__text-icon"/>
                        </div>;
            case 'spectacle':
                return <div className="item__text-icon-container">
                            <img src={spectacle} alt={lang[clang].alt.spectacle} className="item__text-icon"/>
                        </div>;
            case 'movie':
                return <div className="item__text-icon-container">
                            <img src={movie} alt={lang[clang].alt.movie} className="item__text-icon"/>
                        </div>;
            case 'radio':
                return <div className="item__text-icon-container">
                            <img src={radio} alt={lang[clang].alt.radio} className="item__text-icon"/>
                        </div>;
            case 'television':
                return <div className="item__text-icon-container">
                            <img src={tv} alt={lang[clang].alt.tv} className="item__text-icon"/>
                        </div>;
            case 'creative-work':
                return <div className="item__text-icon-subcontainer">
                            <img src={work} alt={lang[clang].alt.creative_work} className="item__text-icon"/>
                        </div>;
            case 'event':
                return <div className="item__text-icon-subcontainer">
                            <img src={event} alt={lang[clang].alt.event} className="item__text-icon"/>
                        </div>;
            case 'externalLinks':
                return <div className="item__text-icon-subcontainer">
                            <img src={linkImg} alt={lang[clang].alt.externalLinks} className="item__text-icon"/>
                        </div>;
            case 'authorCompany':
                return <div className="item__text-icon-subcontainer">
                            <img src={person} alt={lang[clang].alt.author_company} className="item__text-icon"/>
                        </div>;
            default:
                break;
        }

    };

    const isSingle = (type) => ['place', 'publishing-series', 'collection', 'source'].includes(type) || !type;
    const isSingleLink = (type) => ['place', 'publishing-series', 'collection'].includes(type) || !type;

    const getTextItem = () => {
        if (link && type !== 'publishing-series') {
            return <div className={`item__text ${!isSingle(type) ? 'with-img' : ''}`}>
                        {!isSingle(type) && getImg(type)}
                        {!newTab && !isSingleLink(type) &&
                            <Link to={`/item/${type.toLowerCase()}/${link}`}
                                className="item__text--link"
                                title={stripHtml(text)}
                                dangerouslySetInnerHTML={{__html: text}}>
                            </Link>}
                        {!newTab && isSingleLink(type) &&
                            <a href={link} className="item__text--link" title={stripHtml(text)} dangerouslySetInnerHTML={{__html: text}}></a>}
                        {newTab &&
                            <a href={link} target="_blank" title={stripHtml(text)} className="item__text--link" dangerouslySetInnerHTML={{__html: text}}></a>}
                        {isTransit && <sup className="item__text__sup">t</sup>}
                    </div>;
        }
		
        return <div className={`item__text `}>
                    {type && getImg(type)}
                    <span dangerouslySetInnerHTML={{__html: getTextMetadataDataTransformed(text)}}></span>
                    {isTransit && <sup className="item__text__sup">t</sup>}
                </div>;
    };

    return (
        getTextItem()
    );
};


ItemText.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemText);



// WEBPACK FOOTER //
// ./src/components/items/ItemText.js